"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSqlStatementResponseImplementation = exports.GetSqlStatementRequestImplementation = void 0;
const core_1 = require("./core");
class GetSqlStatementRequestImplementation extends core_1.BaseRpcRequest {
    constructor() {
        super(...arguments);
        this.method = "getSqlStatement";
    }
}
exports.GetSqlStatementRequestImplementation = GetSqlStatementRequestImplementation;
class GetSqlStatementResponseImplementation extends core_1.BaseRpcResponse {
}
exports.GetSqlStatementResponseImplementation = GetSqlStatementResponseImplementation;
//# sourceMappingURL=get-sql-statement.type.js.map